
// import React from 'react';
// import Navbar from './Navbar';
// import Footer from './Footer';
// import SideMenu from './SideMenu';

// const ProfilePage = () => {
//   // Sample user data
//   const user = {
//     name: 'Anti Ai',
//     email: 'antiai@gmail.com',
//     photo: 'logo.png', // Replace with actual image URL or file path
//     location: 'Jaipur , Rajasthan',
//     contact: '+91 1234569788',
//     designation: 'Anti Ai Pvt. Ltd.',
//   };

//   return (
//     <div>
//       <Navbar />
//       <div style={{ display: 'flex', minHeight: 'calc(100vh - 120px)' }}>
//         <SideMenu />
//         <div style={{ flex: 1, padding: '20px' }}>
        
//           <h1>Profile</h1>
//           <div className="profile-card">
//             <div className="profile-photo">
//               <img src={user.photo} alt="User Profile" />
//             </div>
//             <div className="profile-info">
//               <h2>{user.name}</h2>
//               <p><strong>Email:</strong> {user.email}</p>
//               <p><strong>Location:</strong> {user.location}</p>
//               <p><strong>Contact:</strong> {user.contact}</p>
//               <p><strong>Designation:</strong> {user.designation}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//       <Footer />
//     </div>
  
//   );
// };

// export default ProfilePage;






import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SideMenu from './SideMenu';

const ProfilePage = () => {
  // Sample user data (You can fetch this from an API later)
  const [user] = useState({
    name: 'Anti.AI Pvt. Ltd.',
    email: 'tanishq.antiai@gmail.com',
    photo: 'logo.png', // Replace with actual image URL or file path
    location: 'Jaipur, Rajasthan',
    contact: '+91 91166 65513',
  });

  // Fetching user data (this is just an example, assuming you'd want to call an API here)
  useEffect(() => {
    // Example: Fetch user data from an API
    // fetch('/api/user-data')
    //   .then((res) => res.json())
    //   .then((data) => setUser(data))
    //   .catch((error) => console.error('Error fetching user data:', error));
  }, []);

  return (
    <div>
      <Navbar />
      <div className="profile-container" style={{ display: 'flex', minHeight: 'calc(100vh - 120px)' }}>
        <SideMenu />
        <div style={{ flex: 1, padding: '20px' ,textAlign:"center"}}>
          <h1 style={{fontVariant:"small-caps" }}>Profile</h1>
          <div className="profile-card">
            <div className="profile-photo">
              <img src={user.photo} alt="User Profile" />
            </div>
            <div className="profile-info " style={{textAlign:"left", marginLeft:"18%"}}>
              <h2 style={{fontVariant:"small-caps"}}>{user.name}</h2>
              <p ><strong>Email:</strong> {user.email}</p>
              <p ><strong>Location:</strong> {user.location}</p>
              <p ><strong>Contact:</strong> {user.contact}</p>
              {/* <p><strong>Designation:</strong> {user.designation}</p> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ProfilePage;
